import { type EditorManager } from 'tinymce';

const suchFeld = document.getElementById('navbar-suche') as HTMLInputElement;
if (suchFeld) {
	const homeUrl = suchFeld.dataset.homeUrl;
	suchFeld.addEventListener('keydown', evt => {
		if (evt.key === 'Enter') {
			window.location.href = `${homeUrl}#suche=${encodeURIComponent(suchFeld.value)}`;
		}
	});
}

if (document.querySelector('#btn-switch-theme')) {
	document.querySelector('#btn-switch-theme').addEventListener('click', evt => {
		evt.preventDefault();
		evt.stopPropagation();
		const reladRequired = ((window as any).tinymce as EditorManager).get().length > 0;
		if (document.documentElement.getAttribute('data-bs-theme')) {
			if (!reladRequired) {
				document.documentElement.removeAttribute('data-bs-theme');
			}
			window.localStorage.setItem('selected-theme', 'light');
		}
		else {
			if (!reladRequired) {
				document.documentElement.setAttribute('data-bs-theme', 'dark');
			}
			window.localStorage.setItem('selected-theme', 'dark');
		}
		if (reladRequired) {
			window.location.reload();
		}
		else {
			(document.querySelector('#navbar-dropdown') as HTMLAnchorElement).click();
			window.dispatchEvent(new Event('jjk:layout:theme-switched'));
		}
	});
}
